import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Faq({ audience }) {
  const { apiFetch } = useAuth();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  const loadFaqs = useCallback(async () => {
    try {
      const data = await apiFetch(`/api/faq/${audience}`);
      setFaqs(data.faqs);
    } catch (err) {
      console.error('Failed to load FAQs:', err);
    } finally {
      setLoading(false);
    }
  }, [apiFetch, audience]);

  useEffect(() => { loadFaqs(); }, [loadFaqs]);

  if (loading) return <div className="loading"><div className="spinner" /></div>;

  // Group FAQs by category
  const grouped = [];
  const seen = new Set();
  for (const faq of faqs) {
    const key = faq.category_id || '__uncategorized__';
    if (!seen.has(key)) {
      seen.add(key);
      grouped.push({ key, name: faq.category_name || null, faqs: [] });
    }
    grouped.find(g => g.key === key).faqs.push(faq);
  }

  return (
    <div className="admin-page">
      <h1 className="page-title">FAQ</h1>
      {faqs.length === 0 ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginTop: 32 }}>
          No FAQs available yet.
        </p>
      ) : (
        grouped.map(group => (
          <div key={group.key} style={{ marginBottom: 20 }}>
            {group.name && (
              <h2 style={{ fontSize: '1rem', color: 'var(--orange)', marginBottom: 8 }}>{group.name}</h2>
            )}
            <div className="faq-list">
              {group.faqs.map(faq => (
                <div key={faq.id} className="faq-item">
                  <div
                    className="faq-question"
                    onClick={() => setExpandedId(expandedId === faq.id ? null : faq.id)}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-toggle">
                      <i className={`fas fa-chevron-${expandedId === faq.id ? 'up' : 'down'}`}></i>
                    </span>
                  </div>
                  {expandedId === faq.id && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
